import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

const Content = observer(() => {
  const { state, items } = store.item!.rec
  const error = state === 'error'

  if (!error && state !== 'ready') return <Loader />
  if (error || !items.length) return <Typo size={11} center tertiary>
    {i18n('NoRecommendationsFound')}
  </Typo>
})

export const ItemsNone = observer(() => {
  return <Space height={160} wide tall center>
    <Content />
  </Space>
})
